import { mutator } from 'satcheljs';
import { onReportingEnabled } from '../actions';
import { getPageStore } from '../store/store';

mutator(onReportingEnabled, (msg) => {
  getPageStore().isReportEnabled = msg.isEnabled;
});
